<div :class="content_class">
  <div class="portfolio-chart">
    <div class="card-body superset-card-body">
      <div class="superset-embedded-container m-0 p-0">

        <!-- Superset Chart -->
        <div :id="chart_id"></div>

        <!-- Loading State -->
        <div v-if="iframe_loading" class="iframe-loading">
          <div class="spinner-border spinner-border-sm me-2" role="status"></div>
          Loading embedded dashboard...
        </div>

      </div>
    </div>
  </div>
</div>
